(function () {
  var imageSelector = '[data-image-load-fade] img, img.image-load-fade';
  var revealVersions = new WeakMap();

  function reveal(image) {
    image.classList.add('is-image-loaded');
  }

  function prepare(image) {
    var version = (revealVersions.get(image) || 0) + 1;
    revealVersions.set(image, version);
    image.classList.remove('is-image-loaded');

    if (image.complete && image.naturalWidth > 0) {
      window.requestAnimationFrame(function () {
        if (revealVersions.get(image) !== version) return;
        reveal(image);
      });
    }
  }

  document.querySelectorAll(imageSelector).forEach(prepare);

  document.addEventListener('load', function (event) {
    if (event.target.matches && event.target.matches(imageSelector)) {
      reveal(event.target);
    }
  }, true);

  /* Fehlerhafte Bilder nicht dauerhaft als unsichtbare Fläche behandeln. */
  document.addEventListener('error', function (event) {
    if (event.target.matches && event.target.matches(imageSelector)) {
      reveal(event.target);
    }
  }, true);

  /* Story-Galerien tauschen die Bildquelle im selben img-Element aus. */
  new MutationObserver(function (records) {
    var changedImages = [];

    records.forEach(function (record) {
      var image = record.target;
      if (!image.matches(imageSelector) || changedImages.indexOf(image) !== -1) return;
      changedImages.push(image);
    });

    changedImages.forEach(prepare);
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset']
  });
})();
